export const Types = {
	EDIT_SENHA_PERFIL: "EDIT_SENHA_PERFIL",
	EDIT_SENHA_PERFIL_FINALLY: "EDIT_SENHA_PERFIL_FINALLY",
};

const INITIAL_STATE = {
	loading_senha: false,
};

export default function senha(state = INITIAL_STATE, action: any) {
	switch (action.type) {
		case Types.EDIT_SENHA_PERFIL:
			return {
				...state,
				loading_senha: true,
			};
		case Types.EDIT_SENHA_PERFIL_FINALLY:
			return {
				...state,
				loading_senha: false,
			};

		default:
			return state;
	}
}

export const SenhaActions = {
	edit_senha: (data: any) => ({
		type: Types.EDIT_SENHA_PERFIL,
		payload: data,
	}),
	edit_senha_finally: () => ({
		type: Types.EDIT_SENHA_PERFIL_FINALLY,
	}),
};
